import React from "react";
import { Carousel } from "react-bootstrap";
import sliderImg from "../../assets/images/slider/01.jpg";
import sliderImg1 from "../../assets/images/slider/02.jpg";
import "../Banner/banner.css";

const Banner = () => {
  return (
    <section className="slider">
      <Carousel interval={4500}>
        <Carousel.Item>
          <img src={sliderImg} className="d-block w-100" alt="Travel slide" />
          <Carousel.Caption>
            <div className="slider_des">
              <h5 className="heading">
                DISCOVER YOUR <span>DREAM DESTINATION</span>
              </h5>
              <p className="sub_text">
                Curated travel experiences designed to inspire, explore and
                relax — all in one journey.
              </p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={sliderImg1} className="d-block w-100" alt="Travel slide" />
          <Carousel.Caption>
            <div className="slider_des">
              <h5 className="heading">
                TRAVEL MADE <span>SIMPLE & MEMORABLE</span>
              </h5>
              <p className="sub_text">
                From beaches to mountains, we help you travel smarter and
                happier.
              </p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </section>
  );
};

export default Banner;
